import { render, staticRenderFns } from "./rateDialog.vue?vue&type=template&id=32e96a42"
import script from "./rateDialog.vue?vue&type=script&lang=ts"
export * from "./rateDialog.vue?vue&type=script&lang=ts"
import style0 from "./rateDialog.vue?vue&type=style&index=0&id=32e96a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports